export const criticalCustomers = ['Vale', 'Usiminas', 'COFCO', 'Alcoa', 'Anglo American', 'Rumo logistica', 'Vix'];
